<template>
  <div>
    <div class="contentMenu" :class="{ marginCenter: centerBtn }">
      <p v-if="centerBtn" class="back" @click="back">返回上一页</p>
      <div style="height: 5px"></div>
      <div v-if="apptodo > 0 && $route.name == 'appcase'" class="app-aj">
        <div class="appdc padding-20">
          待处理案件:({{ apptodo }})
          <span class="app-ba">此处案件为大救星APP用户报案，请尽快处理</span>
        </div>

        <div v-for="(acase, idx) in apptodolst" :key="idx">
          <div class="clan">
            <el-checkbox
              name="appcaselst"
              @change="changeAppcase(idx)"
              v-model="apptodolst[idx].checked"
            ></el-checkbox>
            <span>{{ time(acase.obj.reportTs) }}</span>
            <span
              >由用户<a class="mingc">{{ acase.obj.reportUser }}</a
              >报案</span
            >
            <span>【{{ acase.incidentTypeStr }}】</span>
            <span
              >出险人:{{
                acase.victimList != null && acase.victimList.length > 0
                  ? acase.victimList[0].obj.victimName
                  : ""
              }}{{
                acase.victimList != null &&
                acase.victimList.length > 0 &&
                judgeNull(acase.victimList[0].insuranceCompany)
                  ? ""
                  : ",在保"
              }}</span
            >
            <span
              >出险地:{{
                acase.victimList != null &&
                acase.victimList.length > 0 &&
                acase.generalLocation != null
                  ? setTxt(acase.generalLocation.addr)
                  : ""
              }}</span
            >
          </div>
        </div>
      </div>
      <!-- <addSelect></addSelect> -->
      <div style="margin-left: 20px" v-if="$route.query.typeId == 700">
        其他案件名称：
        <el-input
          placeholder="请输入其他案件名称"
          v-model="reportcase.otherTypeName"
          max="1"
        ></el-input>
      </div>
      <h4 class="marginl10 margint10">
        {{
          this.$route.name != "callCase1" ? "创建案件并启动救援" : "补充信息"
        }}
      </h4>
      <h5 class="marginl10 margint-10">
        A、案件基本信息
        <span class="padding-20 span_node"
          >案件编号：{{ reportcase.caseNo }}</span
        >
        <!-- <el-button style="float: right;margin-right: 60px;" type="primary" @click="draft">草稿</el-button> -->
      </h5>
      <div class="marginl10">
        <div>
          <table class="padding-bj pad-0-10" cellpadding="5">
            <tr>
              <td>
                报案时间:
                <el-date-picker
                  type="datetime"
                  placeholder="选择日期"
                  v-model="reportcase.reportTs"
                  class="marginl10"
                ></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td>
                报案人:
                <el-input
                  placeholder="请输入报案者姓名"
                  v-model="reportcase.reportUser"
                  class="marginl10"
                  @keydown.native="keydown($event)"
                ></el-input>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                报案电话:
                <el-input
                  placeholder="请输入报案者联系电话"
                  v-model="reportcase.reporterContact"
                  class="marginl10"
                  @keydown.native="keydown($event)"
                ></el-input>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td colspan="2" v-if="typeId == 800">
                上门服务时间:
                <el-date-picker
                  type="datetime"
                  placeholder="上门服务时间"
                  v-model="reportcase.incidentTs"
                  class="marginl10"
                ></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td colspan="2" v-else>
                出险时间
                <el-date-picker
                  type="datetime"
                  placeholder="出险时间"
                  v-model="reportcase.incidentTs"
                  class="marginl10"
                ></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
            </tr>
            <tr>
              <td>
                案件信息来源:
                <el-select
                  v-model="reportcase.caseSrc"
                  placeholder="请选择"
                  class="marginl10"
                >
                  <el-option
                    v-for="item in casesrclst"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </td>
              <td>
                来源说明:
                <!-- <el-input placeholder="请输入来源说明" v-model="reportcase.caseSrcDesc" class="marginl10"></el-input> -->
                <changeLanguage
                  :changeText="reportcase.caseSrcDesc"
                  style="display: inline-block"
                  class="marginl10"
                  v-model="reportcase.caseSrcDesc"
                ></changeLanguage>
                &nbsp;
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <span class="">事故类型:</span>
                <el-select
                  v-model="reportcase.accidentType"
                  @change="accidentTypeschange"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in accidentTypes"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td></td>
            </tr>
          </table>
        </div>
      </div>
      <h5 class="marginl10">B、出险信息</h5>
      <div class="marginl10">
        <table class="padding-bj pad-0-10" cellpadding="5">
          <tr>
            <td v-if="typeId == 800">
              <span class="">被保险人:</span>
              <el-input
                placeholder="请输入被保险人姓名"
                v-model="reportcase.victimName"
                class="marginl10"
                @keydown.native="keydown($event)"
              ></el-input>
              &nbsp;
              <span class="must">*</span>
            </td>
            <td v-else>
              <span class="">出险人姓名:</span>
              <el-input
                placeholder="请输入出险人姓名"
                v-model="reportcase.victimName"
                class="marginl10"
                @keydown.native="keydown($event)"
              ></el-input>
              &nbsp;
              <span class="must">*</span>
            </td>
            <td>
              <span class="">性别:</span>
              <el-select
                v-model="reportcase.gender"
                placeholder="请选择"
                class="marginl10 w100"
              >
                <el-option
                  v-for="item in genderlst"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              &nbsp;
              <!-- <span class="must">*</span> -->
            </td>
            <td></td>
          </tr>
          <tr>
            <td v-if="typeId == 800">
              <span class="">被保人证件:</span>
              <el-input
                placeholder="请输入被保人证件"
                v-model="reportcase.idNo"
                class="marginl10"
                @keydown.native="keydown($event)"
              ></el-input>
              &nbsp;
              <!-- <span class="must">*</span> -->
              &nbsp;
              <el-button
                type="primary"
                size="small"
                v-if="typeId != 800"
                @click="getinsurance()"
                >查询保单</el-button
              >
            </td>
            <td v-else>
              <span class="">出险人证件:</span>
              <el-input
                placeholder="请输入出险人证件"
                v-model="reportcase.idNo"
                class="marginl10"
                @keydown.native="keydown($event)"
              ></el-input>
              &nbsp;
              <!-- <span class="must">*</span> -->
              &nbsp;
              <el-button
                type="primary"
                size="small"
                v-if="typeId != 800"
                @click="getinsurance()"
                >查询保单</el-button
              >
            </td>
            <td>
              <span class="">保单号码:</span>
              <el-input
                placeholder="请输入保单号码"
                v-model="reportcase.insurancePolicyNo"
                class="marginl10"
                @blur="insurancePolicyNoblur"
                @keydown.native="keydown($event)"
              ></el-input>
              &nbsp;
              <span class="must">*</span>
              &nbsp;
              <el-button
                type="primary"
                size="small"
                v-if="typeId != 800"
                @click="showinsurance()"
                >保单详情</el-button
              >
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <span class="">所属保险公司:</span>
              <el-select
                v-model="reportcase.insuranceCompanyId"
                @change="suoshuFun"
                class="marginl10 w213"
                placeholder="保险公司"
                filterable
              >
                <el-option
                  v-if="item.insti.name"
                  v-for="item in companies"
                  :key="item.insti.id"
                  :label="item.insti.name"
                  :value="item.insti.id"
                ></el-option>
              </el-select>
              <span
                class="must"
                v-if="
                  tcm[reportcase.insuranceCompanyId] != null &&
                  tcm[reportcase.insuranceCompanyId].inContract != 1
                "
                >*
                <span class="f10">当前保险公司不在合作期内，请知晓</span></span
              >
            </td>
            <td v-if="typeId == 800">
              <span class="">产品名称:</span>
              <el-input
                v-model="reportcase.caseProductName"
                class="marginl10"
              ></el-input>
              <!-- <span class="must">*</span> -->
            </td>
          </tr>
          <tr
            v-if="
              (reportcase.insuranceCompanyId != '' &&
                reportcase.accidentType == '疏通马桶服务') ||
              reportcase.accidentType == '开锁服务' ||
              reportcase.accidentType == '油烟机清洗' ||
              reportcase.accidentType == '油烟机拆洗' ||
              reportcase.accidentType == '保洁2小时' ||
              reportcase.accidentType == '保洁4小时' ||
              reportcase.accidentType == '擦玻璃小户型（100平米下）' ||
              reportcase.accidentType == '擦玻璃大户型（100-150平米）'
            "
          >
            <td v-if="companies1.length != 0">
              <span class="">保险公司子公司:</span>
              <el-select
                v-model="reportcase.subRegulatorId"
                @change="suoshuFunz"
                class="marginl10 w213"
                placeholder="请选择保险公司"
                filterable
              >
                <el-option
                  v-for="item in companies1"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <!-- <span class="must">*</span> -->
            </td>
          </tr>
          <tr>
            <td>
              <span class="">保险公司座席工号:</span>
              <el-input
                v-model="reportcase.insuranceSeat"
                class="marginl10"
              ></el-input>
            </td>
            <td>
              <span class="">小保单号:</span>
              <el-input
                v-model="reportcase.miniPolicy"
                class="marginl10"
                @blur="insurancePolicyNoblur"
                @keydown.native="keydown($event)"
              ></el-input>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span class="">出险地:</span>
              <el-select
                v-model="reportcase.siteabroadExpr"
                @change="caseabroad()"
                class="w75"
                placeholder="境内"
              >
                <el-option
                  v-for="item in abroad"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <span class="must" v-if="reportcase.siteabroadExpr == '境外'"
                >*</span
              >
              <el-select
                v-model="reportcase.nation"
                v-if="reportcase.siteabroadExpr == '境外'"
                @change="loadcounties()"
                class="w120"
                placeholder="请选择国家"
                filterable
              >
                <el-option
                  v-for="item in countries"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

              <span class="must">*</span>
              <el-select
                v-model="reportcase.city"
                class="w130"
                placeholder="请选择地区"
                filterable
              >
                <el-option
                  v-for="item in counties"
                  :key="item.cityCode"
                  :label="item.cityName"
                  :value="item.cityCode"
                ></el-option>
              </el-select>

              <span class="must">*</span>
              <!-- <el-input placeholder="其他详细地址" v-model="reportcase.addr" class="w303"></el-input> -->
              <changeLanguage
                ref="changeLanguage"
                :changeText="reportcase.addr"
                class="w303"
                v-model="reportcase.addr"
              ></changeLanguage>

              <span class="must">*</span>
              <div class="w303">
                <el-input
                  style="width: 200px"
                  v-model="Longitudeandlatitude"
                  @blur="Longitudeandlatitudeblur"
                ></el-input>
                <span style="min-width: 240px; display: inline-block"
                  >经度：{{ reportcase.latitude }}；纬度：{{
                    reportcase.longitude
                  }}</span
                >
                <div>
                  <a
                    href="https://api.map.baidu.com/lbsapi/getpoint/index.html"
                    target="_blank"
                    >获取当前GPS<span class="must">*</span>
                  </a>
                </div>
              </div>
            </td>
            <td></td>
          </tr>

          <tr v-if="typeId == 800">
            <td>
              <span class="">服务类型:</span>
              <el-select v-model="reportcase.accidentType" placeholder="请选择">
                <el-option
                  v-for="item in accidentTypes1"
                  :key="item.serviceType"
                  :label="item.serviceType"
                  :value="item.serviceType"
                ></el-option>
              </el-select>
              &nbsp;
              <span class="must">*</span>
            </td>
            <td></td>
          </tr>
          <tr v-if="typeId != 800">
            <td colspan="2">
              <span class="back-wc">受伤部位:</span>
              <!-- <el-input placeholder="如有请填写" v-model="reportcase.injuredPart" class="w140"></el-input> -->
              <changeLanguage
                :changeText="reportcase.injuredPart"
                class="w88100"
                v-model="reportcase.injuredPart"
              ></changeLanguage>
            </td>
          </tr>
        </table>
      </div>
      <div class="p1026 h50" v-if="typeId != 800">
        <span class="back-wc">天气灾害:</span>
        <el-radio-group v-model="reportcase.weatherIncident" size="mini">
          <el-radio :label="1" border>是</el-radio>
          <el-radio :label="2" border>否</el-radio>
        </el-radio-group>
        <div
          v-if="reportcase.weatherIncident == 1"
          style="display: inline-block"
          class="h50"
        >
          &nbsp;
          <span class="must">*</span>
          <span class="back-wc padding-40">灾害事故标签:</span>
          <el-select
            placeholder="气象灾害"
            v-model="reportcase.weatherTag"
            class="w140"
          >
            <el-option
              v-for="item in disasters"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          &nbsp;
          <span class="must">*</span>
        </div>
      </div>
      <div class="p1026">
        <span class="back-wc" style="vertical-align: top" v-if="typeId != 800"
          >事故经过:</span
        >
        <span class="back-wc" style="vertical-align: top" v-else
          >服务经过:</span
        >
        <!-- <el-input type="textarea" placeholder="请输入内容" v-model="reportcase.incidentDesc" class="w88100"></el-input> -->
        <changeLanguage
          class="w88100"
          :changeText="reportcase.incidentDesc"
          v-model="reportcase.incidentDesc"
        ></changeLanguage>
        <div
          style="display: inline-block; color: #ccc; font-size: 15px"
          v-if="reportcase.accidentType == '疏通马桶服务'"
        >
          <div>服务经过输入内容例如：马桶疏通服务</div>
          <div>*客户马桶因有异物卡住</div>
          <div>*客户家中马桶为蹲便</div>
        </div>
        <div
          style="display: inline-block; color: #ccc; font-size: 15px"
          v-if="reportcase.accidentType == '开锁服务'"
        >
          <div>服务经过输入内容例如：紧急开锁</div>
          <div>*客户忘带钥匙需要开锁</div>
          <div>*客户需要预约开锁</div>
          <div>*客户锁型为王力/保德安锁，请确认是否可以开具</div>
        </div>
      </div>
      <div
        class="c"
        v-if="
          $route.name == 'callCase' ||
          ($route.name == 'callCase1' && typeId != 800)
        "
      >
        <h5 class="marginl10">
          C、保险公司联络人
          <small style="color: red"
            >若此案件为保险公司替用户报案，请务必获取后续对接人联系方式</small
          >
        </h5>
        <ul class="lianluo">
          <li>
            <span class="">保险公司对接人:</span>
            <el-input
              placeholder="请输入保险公司对接人"
              v-model="callCase.contactName"
              class="marginl10"
            ></el-input>
          </li>
          <li>
            <span class="">对接人联系方式:</span>
            <el-input
              placeholder="请输入对接人联系方式"
              v-model="callCase.contactNo"
              class="marginl10"
            ></el-input>
          </li>
        </ul>
        <ul class="lianluo">
          <li>
            <span class="">&nbsp;&nbsp;&nbsp;保险公司名称:</span>
            <el-input
              placeholder="请输入保险公司对接人"
              v-model="callCase.company"
              class="marginl10"
            ></el-input>
          </li>
        </ul>
        <div class="lianluo">
          <span style="vertical-align: top">其他信息:</span>
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="callCase.description"
            class="w88100"
          ></el-input>
        </div>
      </div>

      <div style="text-align: center; margin-top: 20px; padding-bottom: 20px">
        <el-button type="primary" class="w200" @click="submitcase(1, false)"
          >保存案件</el-button
        >
        <el-button type="primary" class="w200" @click="submitcase(2, false)"
          >创立案件</el-button
        >
      </div>
    </div>
    <!-- GPS -->
    <div class="gpsBox" :style="{ visibility: gpsBox ? 'initial' : 'hidden' }">
      <gpsBox
        ref="gpsBox"
        @getGpshid="getGpshid"
        @getGpshid1="getGpshid1"
      ></gpsBox>
    </div>
  </div>
</template>

<script>
// import BaiduMap from 'baidu-map';
import strutils from "@/util/strutils.js";
import { Message } from "element-ui";
import constants from "@/util/constants.js";
import {
  creatCase,
  updataOrdinaryCase,
  getallGoingCase,
  userlist_regulator,
  casecreateEditTempCase,
  rescuecasecase_info,
  regulatorlistservice,
} from "@/views/axios/api.js";
import changeLanguage from "@/components/common/changeLange.vue";
import gpsBox from "@/views/map/searchMap.vue";

import addSelect from "@/views/commonPage/details/jiesuan.vue";
export default {
  data() {
    return {
      Longitudeandlatitude: "",
      fullscreenLoading: false,
      companies1: [],
      cpname: "平安五福临门家财险",
      creatAboutText: "",
      initialCaseId: "",
      initialCaseIdBtn: false,
      gpsBtn: false,
      gpsBox: false,
      centerBtn: false,
      typeId: this.$route.query.typeId,
      apptodo: 0,
      apptodolst: [],
      token:
        this.$route.params.token ||
        JSON.parse(window.localStorage.getItem("data")).data,
      value: "",
      gridData: [
        {
          xu: "1",
          code: "AJ0001",
          address: "美国纽约第五大厦",
          name: "网易黄博士",
          phone: "+86 134764787",
          info: "身份证 5454514251414",
          sex: "男",
          date: "2018年6月5日 18:00",
        },
      ],
      fcdBtn: true,
      reportcase: {
        insuranceSeat: "",
        miniPolicy: "",
        caseProductName: "",
        subRegulatorId: "",
        remark: "",
        token: "",
        reportUser: "",
        reportTs: "",
        reporterContact: "",
        incidentTs: "",
        caseSrc: "",
        // caseNo: "4256544",
        caseInsured: -1,
        // addr: "境内",
        nation: "+86",
        city: "86-11-city area-1101",
        siteabroadExpr: "境内",
        addr: "",
        weatherIncident: 2,
        weatherTag: "",
        accidentType: "",
        victimName: "",
        insurancePolicyNo: "",
        idNo: "",
        insuranceCompanyId: "",
        injuredPart: "",
        incidentDesc: "",
        regulatorId: 1,
        incidentType: "",
        djxId: "",
        // victimId: '',
        latitude: "",
        longitude: "",
        caseSrcDesc: "", //案件来源中英文
        gender: 1,
        //汇合地点
        addr1: "境内",
        rendezvous: "",
        rlng: "",
        rlat: "1",
        nation1: "+86",
        city1: "86-11-city area-1101",
        //end
        channel: "",
        travelId: "",
        subServiceType: "", //星使类型
        xsStart: "",
        xsEnd: "",
        xsDuration: "0",
        tUploadCnts: [],
        hospital: "",
        attendingDoctor: "",
        adContact: "",
        // xsId:'',
        rContact: "",
        otherTypeName: "",
      },
      policy: null,
      companies: [
        {
          insti: {
            name: "江泰救援",
            id: "1",
          },
          inContract: 1,
        },
      ],

      casesrclst: [
        "一键救命",
        "电话求救",
        "保险公司转接",
        "其他",
        "保单卡报案",
        "安全中心报案",
      ],

      abroad: ["境内", "境外"],
      genderlst: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      countries: [
        {
          label: "美国",
          value: "+1",
        },
        {
          label: "加拿大",
          value: "+01",
        },
        {
          label: "俄罗斯",
          value: "+7",
        },
        {
          label: "哈萨克斯坦",
          value: "+07",
        },
        {
          label: "埃及",
          value: "+20",
        },
        {
          label: "南非",
          value: "+27",
        },
        {
          label: "希腊",
          value: "+30",
        },
        {
          label: "荷兰",
          value: "+31",
        },
        {
          label: "比利时",
          value: "+32",
        },
        {
          label: "法国",
          value: "+33",
        },
        {
          label: "西班牙",
          value: "+34",
        },
        {
          label: "匈牙利",
          value: "+36",
        },
        {
          label: "意大利",
          value: "+39",
        },
        {
          label: "罗马尼亚",
          value: "+40",
        },
        {
          label: "瑞士",
          value: "+41",
        },
        {
          label: "奥地利",
          value: "+43",
        },
        {
          label: "英国",
          value: "+44",
        },
        {
          label: "丹麦",
          value: "+45",
        },
        {
          label: "瑞典",
          value: "+46",
        },
        {
          label: "挪威",
          value: "+47",
        },
        {
          label: "波兰",
          value: "+48",
        },
        {
          label: "德国",
          value: "+49",
        },
        {
          label: "秘鲁",
          value: "+51",
        },
        {
          label: "墨西哥",
          value: "+52",
        },
        {
          label: "古巴",
          value: "+53",
        },
        {
          label: "阿根廷",
          value: "+54",
        },
        {
          label: "巴西",
          value: "+55",
        },
        {
          label: "智利",
          value: "+56",
        },
        {
          label: "哥伦比亚",
          value: "+57",
        },
        {
          label: "委内瑞拉",
          value: "+58",
        },
        {
          label: "马来西亚",
          value: "+60",
        },
        {
          label: "澳大利亚",
          value: "+61",
        },
        {
          label: "印度尼西亚",
          value: "+62",
        },
        {
          label: "菲律宾",
          value: "+63",
        },
        {
          label: "新西兰",
          value: "+64",
        },
        {
          label: "新加坡",
          value: "+65",
        },
        {
          label: "泰国",
          value: "+66",
        },
        {
          label: "日本",
          value: "+81",
        },
        {
          label: "韩国",
          value: "+82",
        },
        {
          label: "越南",
          value: "+84",
        },
        {
          label: "中国",
          value: "+86",
        },
        {
          label: "土耳其",
          value: "+90",
        },
        {
          label: "印度",
          value: "+91",
        },
        {
          label: "巴基斯坦",
          value: "+92",
        },
        {
          label: "阿富汗",
          value: "+93",
        },
        {
          label: "斯里兰卡",
          value: "+94",
        },
        {
          label: "缅甸",
          value: "+95",
        },
        {
          label: "伊朗",
          value: "+98",
        },
        {
          label: "南苏丹",
          value: "+211",
        },
        {
          label: "摩洛哥",
          value: "+212",
        },
        {
          label: "阿尔及利亚",
          value: "+213",
        },
        {
          label: "突尼斯",
          value: "+216",
        },
        {
          label: "利比亚",
          value: "+218",
        },
        {
          label: "冈比亚",
          value: "+220",
        },
        {
          label: "塞内加尔",
          value: "+221",
        },
        {
          label: "毛里塔尼亚",
          value: "+222",
        },
        {
          label: "马里",
          value: "+223",
        },
        {
          label: "几内亚",
          value: "+224",
        },
        {
          label: "科特迪瓦",
          value: "+225",
        },
        {
          label: "布基纳法索",
          value: "+226",
        },
        {
          label: "尼日尔",
          value: "+227",
        },
        {
          label: "多哥",
          value: "+228",
        },
        {
          label: "贝宁",
          value: "+229",
        },
        {
          label: "毛里求斯",
          value: "+230",
        },
        {
          label: "利比里亚",
          value: "+231",
        },
        {
          label: "塞拉利昂",
          value: "+232",
        },
        {
          label: "加纳",
          value: "+233",
        },
        {
          label: "尼日利亚",
          value: "+234",
        },
        {
          label: "乍得",
          value: "+235",
        },
        {
          label: "中非共和国",
          value: "+236",
        },
        {
          label: "喀麦隆",
          value: "+237",
        },
        {
          label: "佛得角",
          value: "+238",
        },
        {
          label: "圣多美和普林西比",
          value: "+239",
        },
        {
          label: "赤道几内亚",
          value: "+240",
        },
        {
          label: "加蓬",
          value: "+241",
        },
        {
          label: "刚果",
          value: "+242",
        },
        {
          label: "刚果民主共和国",
          value: "+243",
        },
        {
          label: "安哥拉",
          value: "+244",
        },
        {
          label: "几内亚比绍",
          value: "+245",
        },
        {
          label: "圣赫勒拿岛",
          value: "+247",
        },
        {
          label: "塞舌尔",
          value: "+248",
        },
        {
          label: "苏丹",
          value: "+249",
        },
        {
          label: "卢旺达",
          value: "+250",
        },
        {
          label: "埃塞俄比亚",
          value: "+251",
        },
        {
          label: "索马里",
          value: "+252",
        },
        {
          label: "吉布提",
          value: "+253",
        },
        {
          label: "肯尼亚",
          value: "+254",
        },
        {
          label: "坦桑尼亚",
          value: "+255",
        },
        {
          label: "乌干达",
          value: "+256",
        },
        {
          label: "布隆迪",
          value: "+257",
        },
        {
          label: "莫桑比克",
          value: "+258",
        },
        {
          label: "桑给巴尔",
          value: "+259",
        },
        {
          label: "赞比亚",
          value: "+260",
        },
        {
          label: "马达加斯加",
          value: "+261",
        },
        {
          label: "留尼汪",
          value: "+262",
        },
        {
          label: "津巴布韦",
          value: "+263",
        },
        {
          label: "纳米比亚",
          value: "+264",
        },
        {
          label: "马拉维",
          value: "+265",
        },
        {
          label: "莱索托",
          value: "+266",
        },
        {
          label: "博茨瓦纳",
          value: "+267",
        },
        {
          label: "科摩罗和马约特",
          value: "+269",
        },
        {
          label: "圣赫勒拿岛",
          value: "+290",
        },
        {
          label: "厄立特里亚",
          value: "+291",
        },
        {
          label: "阿鲁巴",
          value: "+297",
        },
        {
          label: "法罗群岛",
          value: "+298",
        },
        {
          label: "格陵兰岛",
          value: "+299",
        },
        {
          label: "直布罗陀",
          value: "+350",
        },
        {
          label: "葡萄牙",
          value: "+351",
        },
        {
          label: "卢森堡",
          value: "+352",
        },
        {
          label: "爱尔兰",
          value: "+353",
        },
        {
          label: "冰岛",
          value: "+354",
        },
        {
          label: "阿尔巴尼亚",
          value: "+355",
        },
        {
          label: "马耳他",
          value: "+356",
        },
        {
          label: "塞浦路斯",
          value: "+357",
        },
        {
          label: "芬兰",
          value: "+358",
        },
        {
          label: "保加利亚",
          value: "+359",
        },
        {
          label: "立陶宛",
          value: "+370",
        },
        {
          label: "拉脱维亚",
          value: "+371",
        },
        {
          label: "爱沙尼亚",
          value: "+372",
        },
        {
          label: "摩尔多瓦",
          value: "+373",
        },
        {
          label: "亚美尼亚",
          value: "+374",
        },
        {
          label: "白俄罗斯",
          value: "+375",
        },
        {
          label: "安道尔",
          value: "+376",
        },
        {
          label: "摩纳哥",
          value: "+377",
        },
        {
          label: "圣马力诺",
          value: "+378",
        },
        {
          label: "梵蒂冈",
          value: "+379",
        },
        {
          label: "乌克兰",
          value: "+380",
        },
        {
          label: "塞尔维亚",
          value: "+381",
        },
        {
          label: "黑山",
          value: "+382",
        },
        {
          label: "克罗地亚",
          value: "+384",
        },
        {
          label: "克罗地亚",
          value: "+385",
        },
        {
          label: "斯洛文尼亚",
          value: "+386",
        },
        {
          label: "波斯尼亚黑塞哥维那",
          value: "+387",
        },
        {
          label: "马其顿共和国",
          value: "+389",
        },
        {
          label: "捷克",
          value: "+420",
        },
        {
          label: "斯洛伐克",
          value: "+421",
        },
        {
          label: "列支敦士登",
          value: "+423",
        },
        {
          label: "福克兰群岛（即马尔维纳斯群岛）",
          value: "+500",
        },
        {
          label: "南乔治亚岛和南桑威奇群岛",
          value: "+0500",
        },
        {
          label: "伯利兹",
          value: "+501",
        },
        {
          label: "危地马拉",
          value: "+502",
        },
        {
          label: "萨尔瓦多",
          value: "+503",
        },
        {
          label: "洪都拉斯",
          value: "+504",
        },
        {
          label: "尼加拉瓜",
          value: "+505",
        },
        {
          label: "哥斯达黎加",
          value: "+506",
        },
        {
          label: "巴拿马",
          value: "+507",
        },
        {
          label: "圣皮埃尔和密克隆群岛",
          value: "+508",
        },
        {
          label: "海地",
          value: "+509",
        },
        {
          label: "瓜德罗普",
          value: "+590",
        },
        {
          label: "玻利维亚",
          value: "+591",
        },
        {
          label: "圭亚那",
          value: "+592",
        },
        {
          label: "厄瓜多尔",
          value: "+593",
        },
        {
          label: "法属圭亚那",
          value: "+594",
        },
        {
          label: "巴拉圭",
          value: "+595",
        },
        {
          label: "马提尼克",
          value: "+596",
        },
        {
          label: "苏里南",
          value: "+597",
        },
        {
          label: "乌拉圭",
          value: "+598",
        },
        {
          label: "荷属圣马丁",
          value: "+599",
        },
        {
          label: "东帝汶",
          value: "+670",
        },
        {
          label: "关岛",
          value: "+1671",
        },
        {
          label: "文莱达鲁萨兰国",
          value: "+673",
        },
        {
          label: "瑙鲁",
          value: "+674",
        },
        {
          label: "巴布亚新几内亚",
          value: "+675",
        },
        {
          label: "汤加",
          value: "+676",
        },
        {
          label: "所罗门群岛",
          value: "+677",
        },
        {
          label: "瓦努阿图",
          value: "+678",
        },
        {
          label: "斐济",
          value: "+679",
        },
        {
          label: "帕劳",
          value: "+680",
        },
        {
          label: "瓦利斯和富圖納群島",
          value: "+681",
        },
        {
          label: "库克群岛",
          value: "+682",
        },
        {
          label: "纽埃",
          value: "+683",
        },
        {
          label: "美属萨摩亚",
          value: "+684",
        },
        {
          label: "萨摩亚",
          value: "+685",
        },
        {
          label: "基里巴斯",
          value: "+686",
        },
        {
          label: "新喀里多尼亚",
          value: "+687",
        },
        {
          label: "图瓦卢",
          value: "+688",
        },
        {
          label: "法属波利尼西亚",
          value: "+689",
        },
        {
          label: "托克劳",
          value: "+690",
        },
        {
          label: "密克罗尼西亚联邦",
          value: "+691",
        },
        {
          label: "马绍尔群岛",
          value: "+692",
        },
        {
          label: "朝鲜",
          value: "+850",
        },
        {
          label: "香港",
          value: "+852",
        },
        {
          label: "澳门",
          value: "+853",
        },
        {
          label: "柬埔寨",
          value: "+855",
        },
        {
          label: "老挝",
          value: "+856",
        },
        {
          label: "孟加拉国",
          value: "+880",
        },
        {
          label: "台湾",
          value: "+886",
        },
        {
          label: "马尔代夫",
          value: "+960",
        },
        {
          label: "黎巴嫩",
          value: "+961",
        },
        {
          label: "约旦",
          value: "+962",
        },
        {
          label: "叙利亚",
          value: "+963",
        },
        {
          label: "伊拉克",
          value: "+964",
        },
        {
          label: "科威特",
          value: "+965",
        },
        {
          label: "沙特阿拉伯",
          value: "+966",
        },
        {
          label: "也门",
          value: "+967",
        },
        {
          label: "阿曼",
          value: "+968",
        },
        {
          label: "巴勒斯坦",
          value: "+970",
        },
        {
          label: "阿拉伯联合酋长国",
          value: "+971",
        },
        {
          label: "以色列",
          value: "+972",
        },
        {
          label: "巴林",
          value: "+973",
        },
        {
          label: "卡塔尔",
          value: "+974",
        },
        {
          label: "不丹",
          value: "+975",
        },
        {
          label: "蒙古",
          value: "+976",
        },
        {
          label: "尼泊尔",
          value: "+977",
        },
        {
          label: "塔吉克斯坦",
          value: "+992",
        },
        {
          label: "土库曼斯坦",
          value: "+993",
        },
        {
          label: "阿塞拜疆",
          value: "+994",
        },
        {
          label: "格鲁吉亚",
          value: "+995",
        },
        {
          label: "吉尔吉斯斯坦",
          value: "+996",
        },
        {
          label: "乌兹别克斯坦",
          value: "+998",
        },
        {
          label: "巴巴多斯",
          value: "+1246",
        },
        {
          label: "安圭拉",
          value: "+1264",
        },
        {
          label: "安提瓜和巴布达",
          value: "+1268",
        },
        {
          label: "美属维尔京群岛",
          value: "+1340",
        },
        {
          label: "开曼群岛",
          value: "+1345",
        },
        {
          label: "百慕大",
          value: "+1441",
        },
        {
          label: "格林纳达",
          value: "+1473",
        },
        {
          label: "特克斯和凯科斯群岛",
          value: "+1649",
        },
        {
          label: "蒙塞拉特岛",
          value: "+1664",
        },
        {
          label: "北马里亚纳群岛",
          value: "+1670",
        },
        {
          label: "圣卢西亚",
          value: "+1758",
        },
        {
          label: "多米尼克",
          value: "+1767",
        },
        {
          label: "圣文森特和格林纳丁斯",
          value: "+1784",
        },
        {
          label: "波多黎各",
          value: "+1787",
        },
        {
          label: "多米尼加共和国",
          value: "+1809",
        },
        {
          label: "特立尼达和多巴哥",
          value: "+1868",
        },
        {
          label: "圣基茨和尼维斯",
          value: "+1869",
        },
        {
          label: "牙买加",
          value: "+1876",
        },
        {
          label: "巴哈马",
          value: "+001",
        },
        {
          label: "斯威士兰",
          value: "+268",
        },
      ],
      counties: [],
      disasters: ["气象灾害", "海洋灾害", "洪水灾害", "地质灾害", "其他"],
      accidentTypes: ["意外伤害", "突发疾病", "财产损失", "道路救援"],
      // accidentTypes1:["马桶疏通", "开锁服务","油烟机清洗","油烟机拆洗","保洁2小时","保洁4小时","擦玻璃小户型（100平米下）","擦玻璃大户型（100-150平米）"],
      accidentTypes1: [],
      tcm: [
        null,
        {
          name: "江泰救援",
          id: "1",
        },
      ],
      callCase: {
        contactName: "", //对接人
        contactNo: "", //联系方式
        company: "", //公司名称
        description: "",
        caseType: 0, //0 普通 1 咨询
        confirmed: 1, //0 待确认  1 已确认
      },
      nowCaseArr: [],
      nowCaseArr1: [],
      toPathFrom: false,
    };
  },
  mounted: function () {
    console.log(this.$route.params.caseList);
    this.loadcompanies();
    this.loadcounties();
    this.loadAppCases();

    // if (this.$route.params.caseList) {
    this.handleAppCase(true, 0, true);
    // }
    if (this.$route.name == "callCase1") {
      this.centerBtn = true;
    }
    this.getnowCase();
    this.getdata();
    this.suoshuFunz();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log(from);
      if (from.name == "caseDetails") {
        vm.toPathFrom = true;
      }
    });
  },
  watch: {
    "reportcase.otherTypeName"() {
      if (this.reportcase.otherTypeName.length > 6) {
        this.reportcase.otherTypeName = this.reportcase.otherTypeName.substring(
          0,
          6
        );
      }
    },
  },
  components: {
    changeLanguage,
    gpsBox,
    addSelect,
  },
  computed: {
    languageIndex() {
      return this.$store.state.language;
    },
  },
  methods: {
    keydown(e) {
      if (e.keyCode == 32) {
        e.returnValue = false;
      }
    },
    suoshuFunz() {
      if (
        this.reportcase.subRegulatorId != "" &&
        this.reportcase.subRegulatorId != null &&
        this.reportcase.subRegulatorId != undefined
      ) {
        regulatorlistservice({
          token: JSON.parse(window.localStorage.getItem("data")).data,
          regulatorId: this.reportcase.regulatorId,
          subRegulatorId: this.reportcase.subRegulatorId,
        }).then((res) => {
          this.reportcase.accidentType = "";
          this.accidentTypes1 = res.data.obj;
          console.log(res);
        });
      }
    },
    Longitudeandlatitudeblur() {
      if (this.Longitudeandlatitude) {
        var m = this.Longitudeandlatitude.split(",");
        console.log(m);
        this.reportcase.latitude = m[1];
        this.reportcase.longitude = m[0];
      }
      console.log(this.Longitudeandlatitude);
    },
    draft() {
      this.$router.push({
        name: "draft",
        params: {
          token: this.token,
        },
        query: {
          typeId: this.typeId,
        },
      });
    },
    accidentTypeschange() {
      console.log(this.reportcase.accidentType);
      if (
        this.reportcase.accidentType == "疏通马桶服务" ||
        this.reportcase.accidentType == "开锁服务" ||
        this.reportcase.accidentType == "油烟机清洗" ||
        this.reportcase.accidentType == "油烟机拆洗" ||
        this.reportcase.accidentType == "保洁2小时" ||
        this.reportcase.accidentType == "保洁4小时" ||
        this.reportcase.accidentType == "擦玻璃小户型（100平米下）" ||
        this.reportcase.accidentType == "擦玻璃大户型（100-150平米）"
      ) {
        this.typeId = 800;
      }
    },
    getdata() {
      userlist_regulator({
        token: JSON.parse(window.localStorage.getItem("data")).data,
        regulatorId: this.reportcase.insuranceCompanyId,
      }).then((res) => {
        this.companies1 = res.data.obj;
        console.log(res);
      });
    },
    getnowCase() {
      //当前案件管理
      var data = {
        token: this.token,
      };
      getallGoingCase(data)
        .then((res) => {
          this.nowCaseArr = res.data.obj;
          this.nowCaseArr1 = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setTime(str) {
      return constants.time(str);
    },
    setTxt(str, status) {
      if (constants.setTxt(str, status)) {
        return constants.setTxt(str, status);
      } else {
        return str;
      }
    },
    back() {
      this.$router.go(-1);
    },
    changeAppcase(idx) {
      this.reportcase.latitude = "";
      this.reportcase.longitude = "";

      this.handleAppCase(true, idx);
    },
    suoshuFun() {
      this.reportcase.regulatorId = this.reportcase.insuranceCompanyId;
      this.reportcase.subRegulatorId = "";
      this.insurancePolicyNoblur();
      this.getdata();
    },
    handleAppCase() {
      var obj = {
        caseId: this.$route.query.caseId,
        token: JSON.parse(window.localStorage.getItem("data")).data,
      };
      rescuecasecase_info(obj).then((res) => {
        this.reportcase = res.data.obj;
        console.log(res);
      });
    },
    // handleAppCase(checked, idx, params, data) {
    //   var z = this;
    //   var ow = null;
    //   if (params) {
    //       ow = this.$route.params.caseList;
    //       this.initialCaseIdBtn=true;
    //   } else {
    //     if (data) {
    //       ow = data.obj;
    //       this.initialCaseIdBtn = true;
    //     } else {
    //       ow = z.apptodolst[idx];
    //     }
    //   }
    //   if (checked) {
    //     for (var i = 0; i < z.apptodolst.length; ++i) {
    //       var o1 = z.apptodolst[i];
    //       if (i != idx) {
    //         o1.checked = false;
    //       } else {
    //         o1.checked = true;
    //       }
    //     }
    //     if (ow != null) {
    //       this.reportcase.otherTypeName=ow.obj.otherTypeName
    //       var o = ow.obj;
    //       z.reportcase.incidentId = o.id;
    //       z.reportcase.initialCaseId=o.initialCaseId;
    //       z.reportcase.reportUser = o.reportUser;
    //       z.reportcase.remark = o.remark;
    //       z.reportcase.caseProductName = o.caseProductName;
    //       z.reportcase.insuranceSeat=o.caseProductName,
    //       z.reportcase.miniPolicy=o.caseProductName,
    //       z.reportcase.subRegulatorId = o.subRegulatorId
    //       if (o.reportTs != null) z.reportcase.reportTs = o.reportTs;
    //       z.reportcase.reporterContact = o.reporterContact;
    //       if (o.incidentTs != null) {
    //         z.reportcase.incidentTs = o.incidentTs;
    //       } else {
    //         z.reportcase.incidentTs = new Date()
    //       }
    //       z.reportcase.caseSrc = o.caseSrc;
    //       z.reportcase.caseNo = o.caseNo;
    //       z.reportcase.caseInsured = o.caseInsured;
    //       if (ow.generalLocation != null) {
    //         var loc = ow.generalLocation;
    //         z.reportcase.siteabroadExpr = loc.nation == "+86" ? "境内" : "境外";
    //         z.reportcase.nation = loc.nation;
    //         z.loadcounties()
    //         z.reportcase.city = loc.city;
    //         z.reportcase.addr = loc.addr;
    //         z.reportcase.latitude = loc.latitude;
    //         z.reportcase.longitude = loc.longitude;
    //         console.log(z.reportcase.addr)
    //       } else {
    //         z.reportcase.siteabroadExpr = "";
    //         z.reportcase.nation = "";
    //         z.reportcase.city = "";
    //         z.reportcase.addr = "";
    //       }
    //       if (o.weatherIncident) {
    //         z.reportcase.weatherIncident = o.weatherIncident;
    //       }

    //       z.reportcase.weatherTag = o.weatherTag;
    //       if (o.accidentType) {
    //         z.reportcase.accidentType = o.accidentType;
    //       }
    //       if (ow.victimList != null && ow.victimList.length > 0) {
    //         var vict = ow.victimList[0].obj;
    //         z.reportcase.victimName = vict.victimName;
    //         z.reportcase.gender = vict.gender;
    //         z.reportcase.insurancePolicyNo = vict.insurancePolicyNo;
    //         z.reportcase.idNo = vict.idNo;
    //         if (vict.insuranceCompanyId != null) {
    //           z.reportcase.insuranceCompanyId = vict.insuranceCompanyId;
    //         } else {
    //           z.reportcase.insuranceCompanyId = 1;
    //         }
    //         this.reportcase.djxId = ow.victimList[0].obj.djxId;
    //         this.reportcase.contact = ow.victimList[0].obj.contact;
    //         this.reportcase.insurancePaper = ow.victimList[0].obj.insurancePaper;
    //         this.reportcase.victimId = ow.victimList[0].obj.id;
    //         z.reportcase.injuredPart = ow.victimList[0].obj.injuredPart;
    //       } else {
    //         z.reportcase.victimName = "";
    //         z.reportcase.gender = "";
    //         z.reportcase.insurancePolicyNo = "";
    //         z.reportcase.idNo = "";
    //         z.reportcase.insuranceCompanyId = 1;
    //       }
    //       z.reportcase.regulatorId = z.reportcase.insuranceCompanyId;
    //       console.log(ow)
    //       z.reportcase.incidentDesc = o.incidentDesc;
    //       z.reportcase.caseSrcDesc = o.caseSrcDesc;
    //       if (this.$route.name == 'callCase1' && ow.insuranceContact) {
    //         z.reportcase.incidentDesc = ow.obj.incidentDesc;
    //         this.callCase.contactName = ow.insuranceContact.contactName;
    //         this.callCase.company = ow.insuranceContact.company;
    //         this.callCase.contactNo = ow.insuranceContact.contactNo;
    //         this.callCase.description = ow.insuranceContact.description;
    //       }

    //     }
    //   }

    // },
    loadcounties(data1, status) {
      var _this = this;
      var cmd = new Object();
      cmd.url = constants.domain + "rescue/case/counties";
      cmd.data = new Object();
      cmd.data.country = this.reportcase.nation;
      cmd.data.token = this.token;
      cmd.succ = function (r) {
        _this.counties = uniq(r);
        var Btn = false;
        if (!status) return;
        if (data1.country == "中国") {
          _this.reportcase.siteabroadExpr = "境内";
        } else {
          _this.reportcase.siteabroadExpr = "境外";
        }
        if (data1.cityCode) {
          _this.reportcase.city = data1.cityCode;
          _this.counties.forEach((item) => {
            if (item.cityCode == data1.cityCode) {
              Btn = true;
            }
          });
          if (!Btn) {
            _this.$message.error("未自动选择城市，请手动选择");
            _this.reportcase.city = "";
          }
        } else {
          _this.$message.error("未自动选择城市，请手动选择");
          _this.reportcase.city = "";
        }
      };
      s2c(cmd);
    },

    loadcompanies() {
      var z = this;
      var cmd = new Object();
      cmd.url = constants.domain + "rescue/user/list_regulator";
      cmd.data = new Object();
      cmd.data.token = this.token;
      cmd.succ = function (r) {
        z.companies = r;
        var ntcm = new Object();
        for (var i = 0; i < r.length; ++i) {
          var nt = r[i];
          ntcm[nt.insti.id] = nt;
        }
        z.tcm = ntcm;
      };
      s2c(cmd);
    },
    getinsurance() {
      var z = this;
      var cmd = new Object();
      cmd.url = constants.domain + "rescue/policy/view";
      cmd.data = new Object();
      cmd.data.idNo = this.reportcase.idNo;
      cmd.data.token = this.token;
      cmd.succ = function (r) {
        if (r != null) {
          z.policy = r;
          z.reportcase.insurancePolicyNo = r.docNo;
          z.reportcase.caseInsured = 1;
          z.reportcase.victimName = r.name;
          if (r.regulatorId != null) {
            z.reportcase.insuranceCompanyId = r.regulatorId;
            z.reportcase.regulatorId = r.regulatorId;
            z.reportcase.idNo = r.nationalId;
          }
        }
      };
      s2c(cmd);
      console.log(this.reportcase.insuranceCompanyId);
    },
    showinsurance() {
      if (this.policy != null) {
        if (this.policy.detailUrl) {
          window.open(this.policy.detailUrl);
        } else {
          this.$message.error("未查到保单信息");
        }
      }
    },

    caseabroad() {
      if (this.reportcase.siteabroadExpr == "境内") {
        this.reportcase.nation = "+86";
        this.loadcounties();
      } else {
        this.reportcase.nation = "";
      }
    },

    loadAppCases() {
      var _this = this;
      var cmd = new Object();
      cmd.url = constants.domain + "rescue/case/list_case_collection";
      cmd.data = new Object();
      cmd.data.status = 90;
      cmd.data.token = this.token;
      cmd.succ = function (r) {
        _this.apptodo = r.length;
        var rr = [];
        for (var i = 0; i < _this.apptodo; i++) {
          var o1 = r[i];
          o1.checked = false;
          _this.apptodolst.push(o1);
        }

        var index1 = "";
        if (_this.$route.params.caseId) {
          _this.apptodolst.forEach((item, index) => {
            if (item.victimList[0].obj.id == _this.$route.params.caseId) {
              index1 = index;
            }
          });
          _this.changeAppcase(index1);
          console.log(_this.apptodolst[index1]);
        }
      };
      s2c(cmd);
    },
    successTo() {
      this.$router.push({
        name: "ComAwait",
        params: {
          token: this.token,
        },
        query: {
          typeId: this.typeId,
        },
      });
    },
    insurancePolicyNoblur() {
      if (this.reportcase.insuranceCompanyId == 8) {
        if (this.typeId == 800) {
          if (this.reportcase.insurancePolicyNo.length > 20) {
            this.$message.error("保单位数超出20位，是否确认继续");
            // return;
          }
          if (this.reportcase.miniPolicy.length != 0) {
            if (this.reportcase.miniPolicy.length > 20) {
              this.$message.error("小保单位数超出20位，是否确认继续");
              // return;
            }
          }
        }
      }
    },
    submitcase(type, status) {
      //insuranceCompanyId
      var z = this;
      var data = {};
      if (type == 2) {
        if (this.$route.query.creat) {
          //从创建关联案件过来的为创建案件
          this.initialCaseIdBtn = false;
        }
        if (this.initialCaseIdBtn) {
          //补充案件不要关联id
          delete this.reportcase.initialCaseId; //关联案件IDinitialCaseId
        } else {
          //创建案件
          delete this.reportcase.incidentId;
          delete this.reportcase.id;
          delete this.reportcase.caseNo;
          delete this.reportcase.victimId;
        }
        if (this.reportcase.insuranceCompanyId == 8) {
          if (this.typeId == 800) {
            if (this.reportcase.insurancePolicyNo.length > 20) {
              this.$message.error("保单位数超出20位，是否确认继续");
              // return;
            }
            if (this.reportcase.miniPolicy != null) {
              if (this.reportcase.miniPolicy.length != 0) {
                if (this.reportcase.miniPolicy.length > 20) {
                  this.$message.error("小保单位数超出20位，是否确认继续");
                  // return;
                }
              }
            }
          }
        }

        if (this.reportcase.latitude == "" || this.reportcase.longitude == "") {
          Message.error("经纬度不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportTs)) {
          Message.error("报案时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportUser)) {
          Message.error("报案人不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reporterContact)) {
          Message.error("报案电话不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.incidentTs)) {
          Message.error("出险时间不能为空");
          return;
        }

        if (stil.judgeNull(this.reportcase.victimName)) {
          Message.error("出险人姓名不能为空");
          return;
        }
        // if (stil.judgeNull(this.reportcase.gender)) {
        //   Message.error("请选择出险人性别");
        //   return;
        // }
        if (
          stil.judgeNull(this.reportcase.nation) ||
          stil.judgeNull(this.reportcase.city) ||
          stil.judgeNull(this.reportcase.addr)
        ) {
          Message.error("出险地不能为空");
          return;
        }
        if (this.typeId) {
          this.reportcase.incidentType = this.typeId;
        }

        if (this.reportcase.weatherIncident != 1) {
          this.reportcase.weatherTag = null;
        }
        if (!constants.setTxt(this.reportcase.addr)) {
          this.reportcase.addr = `<zh-CN>${this.reportcase.addr}</zh-CN><en-US></en-US>`;
        }
        if (!constants.setTxt(this.reportcase.incidentDesc)) {
          this.reportcase.incidentDesc = `<zh-CN>${this.reportcase.incidentDesc}</zh-CN><en-US></en-US>`;
        }
        // //电话报案
        // if (this.$route.name == 'callCase' || this.$route.name == 'callCase1') {
        // 	data = Object.assign(this.reportcase, this.callCase);
        // } else {
        // 	data = this.reportcase
        // }
        if (this.reportcase.insurancePolicyNo) {
          this.reportcase.caseInsured = 1;
        } else {
          this.reportcase.caseInsured = 2;
        }
        if (this.reportcase.channel == "旅责险") {
          this.reportcase.caseInsured = 3;
        }
        data = Object.assign(this.reportcase, this.callCase);
        this.reportcase.token = this.token;
        this.reportcase.incidentTs = new Date(
          this.reportcase.incidentTs
        ).getTime();
        this.reportcase.reportTs = new Date(this.reportcase.reportTs).getTime();
        if (this.$route.query.caseType) {
          this.reportcase.caseType = 1;
        }
        if (this.$route.query.typeId == 700) {
          if (this.reportcase.otherTypeName == "") {
            Message.error("请输入其他案件名称");
            return;
          }
        } else {
          this.reportcase.otherTypeName = "";
        }
        console.log(data);
        if (!this.fcdBtn) return this.$message("不要重复点击");
        this.fcdBtn = false;
        if (!status) {
          delete this.reportcase.victimId;
          this.fullscreenLoading = true;
          creatCase(data, "")
            .then((res) => {
              this.fcdBtn = true;
              if (res.data.code == 0) {
                if (
                  this.$route.name == "callCase" ||
                  this.$route.name == "callCase1"
                ) {
                  // this.$router.go(-1)
                  this.$router.push({
                    name: "ComAwait",
                    params: {
                      token: this.token,
                    },
                    query: {
                      typeId: this.typeId,
                    },
                  });
                } else {
                  this.fullscreenLoading = false;
                  // this.successTo()
                  // this.$router.go(-1)
                  this.$router.push({
                    name: "ComAwait",
                    params: {
                      token: this.token,
                    },
                    query: {
                      typeId: this.typeId,
                    },
                  });
                }
                this.$message.success("创建成功");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          updataOrdinaryCase(data, "")
            .then((res) => {
              console.log(res);
              this.fcdBtn = true;
              if (res.data.code == 0) {
                if (this.$route.path == "/creatNav/callCase") {
                  this.$router.push({
                    path: "/creatNav/consultingCase?caseType=1&status=1",
                  });
                } else {
                  this.$router.go(-1);
                }
                this.$message.success("更新成功");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        if (this.$route.query.creat) {
          //从创建关联案件过来的为创建案件
          this.initialCaseIdBtn = false;
        }
        if (this.initialCaseIdBtn) {
          //补充案件不要关联id
          delete this.reportcase.initialCaseId; //关联案件IDinitialCaseId
        } else {
          //创建案件
          delete this.reportcase.incidentId;
          delete this.reportcase.id;
          delete this.reportcase.caseNo;
          delete this.reportcase.victimId;
        }

        // if (this.reportcase.latitude == '' || this.reportcase.longitude == '') {
        //   Message.error("经纬度不能为空");
        //   return;
        // }
        if (stil.judgeNull(this.reportcase.reportTs)) {
          Message.error("报案时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportUser)) {
          Message.error("报案人不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reporterContact)) {
          Message.error("报案电话不能为空");
          return;
        }
        // if (stil.judgeNull(this.reportcase.incidentTs)) {
        //   Message.error("出险时间不能为空");
        //   return;
        // }

        if (stil.judgeNull(this.reportcase.victimName)) {
          Message.error("出险人姓名不能为空");
          return;
        }
        // if (stil.judgeNull(this.reportcase.gender)) {
        //   Message.error("请选择出险人性别");
        //   return;
        // }
        // if (
        //   stil.judgeNull(this.reportcase.nation) ||
        //   stil.judgeNull(this.reportcase.city) ||
        //   stil.judgeNull(this.reportcase.addr)
        // ) {
        //   Message.error("出险地不能为空");
        //   return;
        // }
        if (this.typeId) {
          this.reportcase.incidentType = this.typeId;
        }

        if (this.reportcase.weatherIncident != 1) {
          this.reportcase.weatherTag = null;
        }
        if (!constants.setTxt(this.reportcase.addr)) {
          this.reportcase.addr = `<zh-CN>${this.reportcase.addr}</zh-CN><en-US></en-US>`;
        }
        if (!constants.setTxt(this.reportcase.incidentDesc)) {
          this.reportcase.incidentDesc = `<zh-CN>${this.reportcase.incidentDesc}</zh-CN><en-US></en-US>`;
        }
        // //电话报案
        // if (this.$route.name == 'callCase' || this.$route.name == 'callCase1') {
        // 	data = Object.assign(this.reportcase, this.callCase);
        // } else {
        // 	data = this.reportcase
        // }
        if (this.reportcase.insurancePolicyNo) {
          this.reportcase.caseInsured = 1;
        } else {
          this.reportcase.caseInsured = 2;
        }
        if (this.reportcase.channel == "旅责险") {
          this.reportcase.caseInsured = 3;
        }
        data = Object.assign(this.reportcase, this.callCase);
        this.reportcase.token = this.token;
        this.reportcase.incidentTs = new Date(
          this.reportcase.incidentTs
        ).getTime();
        this.reportcase.reportTs = new Date(this.reportcase.reportTs).getTime();
        if (this.$route.query.caseType) {
          this.reportcase.caseType = 1;
        }
        if (this.$route.query.typeId == 700) {
          if (this.reportcase.otherTypeName == "") {
            Message.error("请输入其他案件名称");
            return;
          }
        } else {
          this.reportcase.otherTypeName = "";
        }
        console.log(data);
        this.reportcase.incidentId = this.$route.query.caseId;
        // if (!this.fcdBtn) return this.$message('不要重复点击')
        this.fcdBtn = false;
        if (!status) {
          delete this.reportcase.victimId;
          this.fullscreenLoading = true;
          casecreateEditTempCase(data, "")
            .then((res) => {
              this.$message.success("保存成功");
              this.fcdBtn = true;
              // if (res.data.code == 0) {
              //   if (this.$route.name == 'callCase' || this.$route.name == 'callCase1') {
              //     this.$router.go(-1)
              //   } else {
              //     this.fullscreenLoading = false
              //     // this.successTo()
              //     this.$router.go(-1)
              //   }

              // }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          updataOrdinaryCase(data, "")
            .then((res) => {
              console.log(res);
              this.fcdBtn = true;
              if (res.data.code == 0) {
                if (this.$route.path == "/creatNav/callCase") {
                  this.$router.push({
                    path: "/creatNav/consultingCase?caseType=1&status=1",
                  });
                } else {
                  this.$router.go(-1);
                }
                this.$message.success("更新成功");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    getGps() {
      this.gpsBox = true;
      this.$refs.changeLanguage.setBtn();
      this.$refs.gpsBox.parendZx(this.reportcase.addr);
      document.getElementsByTagName("body")[0].style.height = "100vh";
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    },
    getGpshid(data, data1) {
      this.gpsBox = false;
      document.getElementsByTagName("body")[0].style.height = "auto";
      document.getElementsByTagName("body")[0].style.overflow = "auto";
      if (data.lat == "") return;
      this.reportcase.latitude = data.lat;
      this.reportcase.longitude = data.lng;
      // this.reportcase.addr = data.address;
      if (data1 == undefined)
        return this.$message.error("地址未自动匹配，请手动添加！");
      if (data1.country == "中国") {
        this.reportcase.nation = "+86";
      } else {
        this.countries.forEach((item) => {
          if (item.label == data1.country) {
            this.reportcase.nation = item.value;
          }
        });
      }
      this.loadcounties(data1, true);
    },
    getGpshid1() {
      this.gpsBox = false;
      document.getElementsByTagName("body")[0].style.height = "auto";
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    },
    time: constants.time,
    judgeNull: function (val) {
      return stil.judgeNull(val);
    },
    creatAboutFun() {
      if (this.creatAboutText == "")
        return (this.nowCaseArr = this.nowCaseArr1);
      this.nowCaseArr = this.nowCaseArr.filter((item) => {
        return item.obj.obj.caseNo == this.creatAboutText;
      });
    },
  },
};

var stil = strutils;

function forpst(obj) {
  if (stil.judgeNull(obj)) return "";
  var ks = Object.keys(obj);
  var postdata = "";
  for (var i = 0; i < ks.length; ++i) {
    var d = obj[ks[i]];
    if (d == null) continue;
    if (d.constructor == Array) {
      for (var j = 0; j < d.length; ++j) {
        postdata += ks[i] + "=" + encodeURIComponent(d[j]);
        if (j != d.length - 1) {
          postdata += "&";
        }
      }
    } else if (d.constructor == Date) {
      postdata += ks[i] + "=" + d.getTime();
    } else {
      postdata += ks[i] + "=" + encodeURIComponent(d);
    }
    if (i != ks.length - 1) {
      postdata += "&";
    }
  }
  return postdata;
}

function s2c(cmd) {
  fetch(cmd.url, {
    method: "POST",
    body: forpst(cmd.data),
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then(function (res) {
      //console.log(res);
      return res.json();
    })
    .then(function (data) {
      if (data.code != 0) {
        var handled = false;
        if (cmd.transerr != null) {
          handled = cmd.transerr(data.code);
        }
        if (!handled) {
          var errtxt = e2t(data.code);
          Message.error(errtxt);
        }
      } else {
        cmd.succ(data.obj);
      }
    });
}

function e2t(errcode) {
  errcode = "ERR_" + errcode;
  if ("ERR_100001" == errcode) return "参数异常，请重新提交";
  if ("ERR_101000" == errcode) return "登录过期，请重新登录";
  if ("ERR_102000" == errcode) return "用户类型错误";
  if ("ERR_102002" == errcode) return "找不到此机构";
  if ("ERR_102003" == errcode) return "合约已失效";
  if ("ERR_102004" == errcode) return "案件状态错误，无法更新";
  if ("ERR_102005" == errcode) return "案件更新失败";
  if ("ERR_102006" == errcode) return "找不到此机构";
  if ("ERR_102007" == errcode) return "机构保存错误";
  if ("ERR_102008" == errcode) return "找不到此机构合约";
  if ("ERR_102009" == errcode) return "找不到此机构收费方式";
  if ("ERR_102010" == errcode) return "合约保存错误";
  if ("ERR_102011" == errcode) return "找不到此用户";
  if ("ERR_102012" == errcode) return "此案件已创立";
  if ("ERR_101001" == errcode) return "找不到此案件";
  if ("ERR_101002" == errcode) return "找不到方案";
  if ("ERR_101003" == errcode) return "您没有操作权限，请联系管理员";
  if ("ERR_102000" == errcode) return "找不到当前操作状态";
  if ("ERR_101004" == errcode) return "找不到案件出险人";
  if ("ERR_101010" == errcode) return "找不到此方案对应的服务清单";
  if ("ERR_101005" == errcode) return "此案件未推送机构";
  if ("ERR_101006" == errcode) return "救援机构尚未提交方案";
  if ("ERR_101007" == errcode) return "此案已审核，不能修改";
  if ("ERR_101008" == errcode) return "请勿重新提交方案";
  if ("ERR_101009" == errcode) return "找不到此上传资源，无法修改";
  if ("ERR_100000" == errcode) return "未知错误";
  return errcode;
}

function uniq(array) {
  var temp = [];
  var index = [];
  var l = array.length;
  for (var i = 0; i < l; i++) {
    for (var j = i + 1; j < l; j++) {
      if (array[i].cityCode == array[j].cityCode) {
        i++;
        j = i;
      }
    }
    temp.push(array[i]);
    index.push(i);
  }
  return temp;
}
</script>

<style scoped>
@import url("./style.css");
/* @import url("./js/elementUI/index.css"); */

input.el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}

td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.margint10 {
  padding-top: 10px;
}

.el-input,
.el-select {
  width: 50%;
}

.el-input__inner,
.el-input--suffix {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 50%;
}

.lisave {
  font-size: 10px;
  color: #399cff;
  cursor: pointer;
}

.w140 {
  width: 140px;
}

.w213 {
  width: 213px;
}

.w120 {
  width: 120px;
}

.f10 {
  font-size: 10px;
}

.w75 {
  width: 75px;
}

.w130 {
  width: 130px;
}

.w303 {
  width: 303px;
  display: inline-block;
}

.w88100 {
  width: 40%;
  display: inline-block;
}

.w200 {
  width: 200px;
}

.mgt5 {
  margin-top: 5px;
}

.mgt15 {
  margin-top: 15px;
}

.p1026 {
  padding: 10px 26px;
}

.h50 {
  height: 50px;
  line-height: 50px;
}

.span_node {
  font-weight: normal;
  font-size: 14px;
}

.w100 {
  width: 100px;
}

.app-aj div {
  padding: 0;
  margin: 10px 0;
}

.lianluo {
  overflow: hidden;
  font-size: 14px;
  margin-top: 20px;
  padding: 0 15px;
}

.lianluo li {
  float: left;
  width: 50%;
}

.lianluo li .must {
  color: red;
}

.marginCenter {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  position: relative;
  padding-top: 20px;
}

.back {
  background: url(./images/back.png) left center no-repeat;
  padding-left: 20px;
  background-size: 15px;
  cursor: pointer;
  margin-left: 20px;
}

.blue {
  color: #00abf9;
  cursor: pointer;
}

.gpsBox {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: powderblue;
  overflow: hidden;
}

.lianluo span {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/otherdraftdetails.vue